<template>
  <div class="backStack-issue-wrap informationCreate">
    <From
      ref="formRef"
      layoutType="grid"
      :isErrorMessage="false"
      :optionList="formRows"
      :formRules="formRules"
      :defaultModel="defaultModel"
    >
    </From>
    <div class="backStack-issue-footer-wrap">
      <div class="submit-wrap">
        <!-- <a-button class="submit-audit" @click="preView">保存预览</a-button> -->
        <a-button class="submit-audit" @click="toAudit" :loading="loading"
          >保存并发布</a-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import From from '../../components/formTable/form.vue'
import mixinsBackStack from '@/mixins/backStack'
import mixinConfigSetting from '@/mixins/mixinConfigSetting'
import mixinFakeData from '@/mixins/makeFakerData'
import { formRules, formRows } from './configs/formOptions.js'
import { getVideoInfoDetail, updateVideoInfo } from '@/api/MTrainVideo.js'

export default {
  mixins: [mixinsBackStack, mixinConfigSetting, mixinFakeData],
  data() {
    return {
      loading: false,
      formRows, // 表单item配置
      formRules, // 表单校验规则配置
      defaultModel: {},
      detailId: null,
      isRead: false,
    }
  },
  components: {
    From,
  },
  created() {
    this.initSetting()
  },
  methods: {
    // 初始化数据
    initSetting() {
      const { id } = this.$route.query
      this.detailId = id
      this.initDefaultModel()
    },
    // 获取默认值
    async initDefaultModel() {
      const { data } = await getVideoInfoDetail(this.detailId)
      this.handleResult(data)
    },
    handleResult(instance) {
      const { fileUploadVo, fileVo, ...otherParams } = instance
      this.defaultModel = {
        ...otherParams,
        fileId: fileUploadVo,
        fileImgUrl: fileVo ? [{
          fileName: fileVo.fileName,
          filePath: fileVo.url,
          id: fileVo.fileId
        }] : [],
      }
    },
    readChange(e) {
      const { target } = e
      this.isRead = target.checked
    },
    // 参数处理
    beforeRequest() {
      const { detailId } = this
      console.log(this.$refs.formRef.formModel, 'this.$refs.formRef.formModel');
      const { fileImgUrl, ...formValue } = this.$refs.formRef.formModel
      const fileId = this.handlerAnnexIds(formValue)
      const imgIds = this.handlerPicPathIds(fileImgUrl).join(',')
      const status = 1
      const params = {
        ...formValue,
        id: detailId,
        fileId,
        fileImgUrl: imgIds,
        status,
      }
      return params
    },
    handlerAnnexIds(instance) {
      const { fileId } = instance
      if (!fileId) return []
      return fileId.id || fileId.fileId
    },
    handlerPicPathIds(picPath) {
      if (!picPath) return []
      return picPath.reduce((pre, item) => {
        console.log(item, 'item');
        if (item.response) {
          const { fileId } = item.response.data[0]
          pre.push(fileId)
        } else {
          pre.push(item.fileId)
        }
        return pre
      }, [])
    },
    async toAudit() {
      this.loading = true
      const v = this.$refs.formRef.validatedForm()
      if (!v) return
      try {
        const params = this.beforeRequest()
        const { msg, code } = await updateVideoInfo(params)
        this.$apiStatusHandler(code, msg)
        if (code === 200) {
          this.$router.push({ name: 'informationTrainingvideo' })
        }
      } catch (error) {
        this.$apiStatusHandler(99, error.message)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
